import { Component, OnInit } from '@angular/core';

/**
 * [Movemeback ui component library]
 * Messaging component
 */
@Component({
  selector: 'mmb-ui-messaging',
  templateUrl: './messaging.component.html',
  styleUrls: ['./messaging.component.scss']
})
export class MessagingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
